import React, { useState } from "react";
import CommonModal from "../../Components/CommonModal";
import CommonButton from "../../Components/CommonButton";
import { sharingQuetionService, deleteQuestionSharingService } from "../../services";

const ShareControlModal = ({ show, onHide, organizationId, controlQuestionId, shared_with_emails = [], onRefreshQuestions }) => {
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [deletingId, setDeletingId] = useState(null);
  const [deleteError, setDeleteError] = useState("");

  const handleShare = async (data) => {
    const payload = {
      organization_id: sessionStorage.getItem("organization_id"),
      control_question_id: controlQuestionId,
      shared_with_email: data.shared_with_email,
      message: data.message,
    };

    try {
      setLoading(true);
      setSubmitError("");
      const res = await sharingQuetionService(payload);

      if (res?.statusCode?.status) {
        onHide();
      } else {
        setSubmitError(res?.errors?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Share failed:", error);
      setSubmitError("Failed to share. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (questionSharingId) => {
    if (!questionSharingId) return;

    try {
      setDeletingId(questionSharingId);
      setDeleteError("");

      const res = await deleteQuestionSharingService(questionSharingId);

      if (res?.statusCode?.status) {
        setDeleteError("");
        if (onRefreshQuestions) onRefreshQuestions();
        if (onHide) onHide();
      } else {
        setDeleteError(res?.errors?.message || res?.statusCode?.error?.message || "Failed to delete. Please try again.");
      }
    } catch (error) {
      console.error("Delete failed:", error);
      setDeleteError(error?.response?.data?.message || error?.message || "Failed to delete. Please try again.");
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title="Share Control"
      subtitle="Add another email to share with"
      fields={[
        { name: "shared_with_email", label: "Email", type: "email", placeholder: "Enter email address", required: true },
        { name: "message", label: "Message", type: "textarea", placeholder: "Enter message", rows: 3 },
      ]}
      defaultValues={{ shared_with_email: "", message: "" }}
      onSubmit={handleShare}
      error={submitError}
      buttons={[
        { text: "Cancel", variant: "secondary", onClick: onHide, disabled: loading },
        { text: "Share", variant: "primary", type: "submit", loading, loadingText: "Sharing…" },
      ]}
    >
      {shared_with_emails.length > 0 && (
        <div style={{ marginTop: 4 }}>
          <p style={{ color: "var(--color-text-secondary)", fontSize: 12, fontWeight: 600, margin: "0 0 8px" }}>
            Shared With
          </p>

          {deleteError && (
            <p
              style={{
                color: "var(--color-danger)",
                fontSize: 12.5,
                background: "var(--color-danger-soft)",
                border: "1px solid var(--color-danger)",
                borderRadius: "var(--radius-sm)",
                padding: "8px 12px",
                margin: "0 0 10px",
              }}
            >
              {deleteError}
            </p>
          )}

          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 8 }}>
            {shared_with_emails.map((item, index) => (
              <li
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 12,
                  background: "var(--color-surface-muted)",
                  border: "1px solid var(--color-border)",
                  borderRadius: "var(--radius-sm)",
                  padding: "8px 12px",
                }}
              >
                <span style={{ color: "var(--color-text-primary)", fontSize: 13 }}>{item.shared_with_email}</span>
                <CommonButton
                  text={deletingId === item.question_sharing_id ? "Removing…" : "Remove"}
                  variant="danger"
                  onClick={() => handleDelete(item.question_sharing_id)}
                  disable={deletingId === item.question_sharing_id}
                />
              </li>
            ))}
          </ul>

          <hr style={{ borderColor: "var(--color-border)", margin: "16px 0 0" }} />
        </div>
      )}
    </CommonModal>
  );
};

export default ShareControlModal;
